import { cva } from 'class-variance-authority'

export const timelineStyles = cva('flex flex-col')

export const stepCircleStyles = cva(
  `
    flex
    items-center
    justify-center
    rounded-full
    w-9
    h-9
    flex-shrink-0
    border-2
  `,
  {
    variants: {
      status: {
        not_started: 'bg-neutral-0 border-neutral-200',
        in_progress: 'bg-neutral-0 border-green-100',
        review: 'bg-neutral-0 border-green-100',
        complete: 'bg-green-100 border-green-100',
      },
    },
    defaultVariants: {
      status: 'not_started',
    },
  }
)

export const connectorStyles = cva('w-0.5 flex-1 min-h-3 bg-neutral-200')

export const stepLabelStyles = cva('pt-2 label-sm text-neutral-900', {
  variants: {
    status: {
      not_started: '',
      in_progress: 'font-semibold',
      review: 'font-semibold',
      complete: '',
    },
  },
  defaultVariants: {
    status: 'not_started',
  },
})
